export class SubmenuActiveValueConverter {
    toView(row, currentUrl) {
        // note: currentUrl not used, but for some reason (bug?) is required to get the binding for active menu items.
        var css = '';

        if (row.isActive) {
            css = 'selected';
        } else {
            if (row.settings.isParent) {
                css += ' disabled';

                row.children.forEach(function (submenu) {
                    if (submenu.isActive) {
                        css += ' selected';
                    }
                });
            }
        }

        return css;
    }
}
